<template lang="pug">
  .return-visitor-xsell
    Xsell
      transition-group(name="fade" tag="div")
        XsellProduct(v-for="item in items" :item="item" :key="item.id" @add-product="addProductToCart" :can-attach="canAttachThisItem(item)" :processing="addingProduct == item.id").row

</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import Xsell from "../../../Xsell/Xsell";
  import XsellProduct from "../../../Xsell/XsellProduct/XsellProduct";

  export default {
    name: "ReturnVisitorXsell",
    components: {
      XsellProduct,
      Xsell
    },

    computed: {
      ...mapState('cart', [
        'cart',
        'addingProduct'
      ]),

      ...mapGetters('cart', [
        'productIdInCart',
        'subWithSubAttachments'
      ]),

      items() {
        return this.cart.addons.filter(item => !this.productIdInCart(item.id)).slice(0, 3);
      }
    },

    methods: {
      ...mapActions('cart', [
        'loadCart',
        'addToCart'
      ]),

      addProductToCart(e, item, attachToSub) {
        let payload = {
          productId: item.id,
          ctaSource: 'Return Visitor Xsell'
        };

        if (attachToSub) {
          payload.subscription = this.subWithSubAttachments.subscription;
        }

        this.addToCart(payload);
      },

      canAttachThisItem(item) {
        return (this.subWithSubAttachments.subscriptionAttachments || []).some(att => att.code == item.productType);
      },
    },

    mounted() {
      this.loadCart();
    }
  }
</script>

<style scoped lang="stylus">

</style>